// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"25":"cb110e7f","265":"d59c3ab5","297":"8a9d0e85","643":"0d4804d9","692":"daa5f60b","703":"6a16f91b","787":"83869ce6"}[chunkId] + ".chunk.js";
};